export const isParentCompany = (id: number | undefined) => {
  let isParent = false;
  if (id && (id === 1 || id === 32)) {
    isParent = true;
  }
  return isParent;
};
